import { isOfType } from '../helpers'

const NavigatorEntityTypeArray = [
  'WellsFolder',
  'RIGISFolder',
  'MarkersFolder',
  'Marker',
  'Interpretation',
  'HorizonsFolder',
  'Interpretation2D',
  'Interpretation3D',
  'FaultsFolder',
  'PolygonsFolder',
  'MapsFolder',
  'Map',
  'Survey3D',
  'Survey2D',
  'SurveyFolder',
  'Well',
  'Polygon',
  'Fault',
  'Lithology',
  'Horizon',
  'Saturation',
  'PointsFolder',
  'Points',
  'None',
] as const

export type NavigatorEntityType = (typeof NavigatorEntityTypeArray)[number]

export const isNavigatorType = isOfType(NavigatorEntityTypeArray)
